import React, { useState } from 'react';

const AddCheckItemTemplatePopupHOC = (Component: any) =>
    function Comp(props: any) {
        const [showAddCheckItemTemplatePopup, setShowAddCheckItemTemplatePopup] =
            useState<boolean>(false);

        const addToggleHandler = () => {
            setShowAddCheckItemTemplatePopup(!showAddCheckItemTemplatePopup);
        };

        return (
            <Component
                showAddCheckItemTemplatePopup={showAddCheckItemTemplatePopup}
                addToggleHandler={addToggleHandler}
                {...props}
            />
        );
    };

export default AddCheckItemTemplatePopupHOC;
